import noop from 'lodash/noop';

import {
  getItem as getItemLocal,
  removeItem as removeItemLocal,
  setItem as setItemLocal
} from 'utils/storage/localStorage';

import type {
  FacebookButtonModalType,
  FacebookButtonWindowObject
} from '../types';

export const DEFAULT_FB_OBJECT: FacebookButtonWindowObject = {
  getLoginStatus: noop,
  login: noop,
  logout: noop
};

export const CREATE_PROFILE_TEMP_AUTH_STORAGE_KEY = 'create_profile_temp_auth';
export const MODAL_LOCAL_STORAGE_KEY = 'facebook_modal';
export const NUM_MILLISECONDS_IN_THIRTY_DAYS = 2592000000;

export const getLocalStorageKey = (
  creatorProfileId: number
): string => (
  `${MODAL_LOCAL_STORAGE_KEY}_${creatorProfileId}`
);

export const hasModalHiddenTimePassed = async (
  creatorProfileId: number
): Promise<boolean> => {
  const storageKey = getLocalStorageKey(creatorProfileId);
  const storedTimestamp = await getItemLocal(storageKey);
  const now = new Date();

  return !storedTimestamp || (now.getTime() - Number(storedTimestamp)) >= NUM_MILLISECONDS_IN_THIRTY_DAYS;
};

export const handleSetModalStorage = async (
  creatorProfileId: number,
  reset: boolean = false
): Promise<void> => {
  const storageKey = getLocalStorageKey(creatorProfileId);
  const storedTimestamp = await getItemLocal(storageKey);
  const now = (new Date()).getTime();
  const updatedTimestamp = reset || !storedTimestamp ? now : storedTimestamp;

  setItemLocal(storageKey, String(updatedTimestamp));
};

export const handleRemoveModalStorage = (
  creatorProfileId: number
): void => (
  removeItemLocal(getLocalStorageKey(creatorProfileId))
);

export const determineModalType = async (
  creatorProfileId: number,
  isFBLoginActive: boolean,
  isFBLoginExpired: boolean
): Promise<FacebookButtonModalType | null> => {
  const hasHiddenTimePassed = await hasModalHiddenTimePassed(creatorProfileId ?? -1);

  if (isFBLoginExpired && hasHiddenTimePassed) {
    return 'expired';
  }

  if (!isFBLoginActive && hasHiddenTimePassed) {
    return 'login';
  }

  return null;
};
